module.exports = __webpack_public_path__ + "static/img/ud_device_bkg.15582889.png";